import { yup } from '@framework/validation/initYup.ts';

/**
 * Validatore che verifica che il codice sia valido.
 */
export const widgetCodeSchema = yup
  .string()
  .matches(
    /^[a-zA-Z]([a-zA-Z0-9_-]*)$/,
    'Il codice deve iniziare con una lettera e può contenere solo lettere, numeri, - e _',
  )
  .required()
  .label('Codice');
